import { Box } from '@mui/material';
import HtmlScreenLoader from '../components/HtmlScreenLoader';

const PrivacyPolicy: React.FC = () => (
  <Box marginTop={5}>
    <HtmlScreenLoader filename="privacypolicy.html" />
  </Box>
);

export default PrivacyPolicy;
